/* eslint-disable */
/* el-Dialog可拖拽 */
import Vue from 'vue'
Vue.directive('dialogDrag', {
  bind (el, binding, vnode, oldVnode) {
    // 获取拖拽内容头部
    const dialogHeaderEl = el.querySelector('.el-dialog__header')
    const dragDom = el.querySelector('.el-dialog')
    dialogHeaderEl.style.cursor = 'move'
    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = window.getComputedStyle(dragDom, null) || dragDom.currentStyle
    // 鼠标按下事件
    dialogHeaderEl.onmousedown = (e) => {
      // 鼠标按下，计算当前元素距离可视区的距离 (鼠标点击位置距离可视窗口的距离)
      const disX = e.clientX - dialogHeaderEl.offsetLeft
      const disY = e.clientY - dialogHeaderEl.offsetTop
      const dragDomLeft = dragDom.offsetLeft // 对话框距离左边的距离
      console.log(dragDomLeft)
      const dragDomRight = document.body.clientWidth - dragDom.offsetLeft - dragDom.offsetWidth  // 对话框距离右边的距离
      const dragDomTop = dragDom.offsetTop  // 对话框距离顶部
      const dragDomBottom = document.documentElement.clientHeight - dragDomTop - dragDom.offsetHeight  // 对话框距离底部
      // 获取到的值带px 正则匹配替换
      let styL, styT
      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if (sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100)
        styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100)
      } else {
        styL = +sty.left.replace(/\px/g, '')
        styT = +sty.top.replace(/\px/g, '')
      }
      //鼠标拖拽事件
      document.onmousemove = function (e) {

        let l = e.clientX - disX//鼠标左移动的距离
        let t = e.clientY - disY//鼠标上移动的距离
        //向左移动
        if (l < 0 && Math.abs(l) > dragDomLeft) {
          l = -dragDomLeft
        }
        //向右移动
        else if (l > 0 && l > dragDomRight) {
          l = dragDomRight
        }
        //向上移动
        if (t < 0 && Math.abs(t) > dragDomTop) {
          t = -dragDomTop
        }
        //向下移动
        else if (t > 0 && t > dragDomBottom) {
          t = dragDomBottom
        }
        // 移动当前元素
        dragDom.style.left = `${l + styL}px`;
        dragDom.style.top = `${t + styT}px`;
      }

      document.onmouseup = function (e) {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
})
/* eslint-disable */


// WEBPACK FOOTER //
// ./src/utils/eldialogMove.js